import { render } from "./DateFormats.vue?vue&type=template&id=bb0b1348"
import script from "./DateFormats.vue?vue&type=script&lang=js"
export * from "./DateFormats.vue?vue&type=script&lang=js"
script.render = render

export default script